const queue = [];
const listeners = new Set();

function emit() {
  const current = queue[0] || null;
  listeners.forEach((listener) => listener(current));
}

export function subscribeDialog(listener) {
  listeners.add(listener);
  listener(queue[0] || null);
  return () => listeners.delete(listener);
}

function openDialog(dialog) {
  return new Promise((resolve) => {
    const entry = {
      ...dialog,
      resolve: (value) => {
        const index = queue.indexOf(entry);
        if (index >= 0) queue.splice(index, 1);
        emit();
        resolve(value);
      },
    };
    queue.push(entry);
    emit();
  });
}

export function confirmDialog({ title, message, confirmLabel = "OK", cancelLabel = "Cancel", danger = false } = {}) {
  return openDialog({ kind: "confirm", title, message, confirmLabel, cancelLabel, danger });
}

export function alertDialog({ title, message, confirmLabel = "OK" } = {}) {
  return openDialog({ kind: "alert", title, message, confirmLabel });
}
